import { gql } from '@apollo/client';

export enum OrganizationPersonOrder {
  NameAsc = 'LASTNAMEASCTHENFIRSTNAMEASC',
  NameDesc = 'LASTNAMEDESCTHENFIRSTNAMEDESC',
  DomainAsc = 'DOMAINASC',
  DomainDesc = 'DOMAINDESC'
}

export const GetOrganizationUsers = gql`
  query GetOrganizationUsers($filter: OrganizationPersonFilterInput!, $first: Int, $offset: Int, $orderBy: OrganizationPersonOrder) {
    usersOfOrganization(filter: $filter, first: $first, offset: $offset, orderBy: $orderBy) {
      edges {
        node {
          immutableId
          lastName
          firstName
          email
          avatar {
            initials
            color
          }
          status
          creationDate
          domain
          identityDirectories
          subscribedAccounts {
            code
            name
          }
          administratedAccounts {
            code
            name
          }
        }
      }
      pageInfo {
        hasNextPage
      }
      totalCount
    }
  }
`;
